import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
//import Home from '../views/Home/index.vue'
Vue.use(VueRouter)

const routes: Array<RouteConfig> = [{
    path: '/',
    name: 'index',
    component: () => import('../views/index/index.vue'),
    meta: {
      title: '少儿社',
      show: false,
    }
  }, {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    meta: {
        keepAlive: true,
        title: '听力训练音频',
        show: false,
    }
  }, {
    path: '/feedback',
    name: 'feedback',
    component: () => import('../views/feedback/index.vue'),
    meta: {
      title: '反馈',
      show: false,
    }
  }, {
    path: '/details',
    name: 'detailsInfo',
    component: () => import('../views/details/index.vue'), //音频;
    meta: {
      title: '听力训练音频',
      show: false,
    }
  }, {
    path: '/download',
    name: 'download',
    component: () => import('../views/download/index.vue'),
    meta: {
      title: '下载',
      show: false,
    }
  }, {
    path: '/booklist',
    name: 'booklist',
    component: () => import('../views/booklist/index.vue'), //心理健康 书籍列表;
    meta: {
      title: '书籍',
      show: false,
    }
  }, {
    path: '/mentalhealth',
    name: 'mentalhealth',
    component: () => import('../views/mentalhealth/index.vue'), //心理健康书籍;
    meta: {
        keepAlive: true,
        title: '心理健康',
        show: false,
    }
  },{
    path: '/writingBook',
    name: 'writingBook',
    component: () => import('../views/writingBook/index.vue'), //心理健康书籍;
    meta: {
        keepAlive: true,
        title: '英语书写本',
        show: false,
    }
  },{
    path: '/writingBookDetail',
    name: 'writingBookDetail',
    component: () => import('../views/writingBookDetail/index.vue'), //心理健康书籍;
    meta: {
        keepAlive: true,
        title: '英语书写本详情',
        show: false,
    }
  },{
    path: '/mentalhealthDetails',
    name: 'mentalhealthDetails',
    component: () => import('../views/mentalhealthDetails/index.vue'), //心理健康书籍 章节详情页;
    meta: {
      title: '心理健康',
      show: false,
    }
  },{
    path: '/showpdf',
    name: 'showpdf',
    component: () => import('../views/showpdf/index.vue'), //pdf 展示;
    meta: {
      title: '',
      show: false,
    }
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router
